import { HttpRequest } from '#instruments/utils/HttpRequest';
import { getMindboxDeviceUUID } from '~/shared/lib';

export interface IMindboxPaymentQuery {
  customer: {
    email: string;
    firstName: string;
    mobilePhone: string;
    customFields: {
      region: string;
      ids: {
        websiteid: string;
      };
      ktoBudetPolsovatsyaKplus: string[];
      buhgaterskiiBlock: string[];
      yuridicheskiiBlock: string[];
      dopolnitelnyeBloki: string[];
    };
    subscriptions: [
      {
        pointOfContact: 'Email';
      },
    ];
  };
}
export interface IMindboxBigTestDriveQuery {
  customer: {
    email: string;
    firstName: string;
    mobilePhone: string;
    customFields: {
      region: string;
      ids: {
        websiteid: string;
      };
    };
    subscriptions: [
      {
        pointOfContact: 'Email';
      },
    ];
  };
}
export interface IMindboxKomplektNalogovayareforma2025Query {
  customer: {
    email: string;
    firstName: string;
    mobilePhone: string;
    customFields: {
      region: string;
      ids: {
        websiteid: string;
      };
    };
    subscriptions: [
      {
        pointOfContact: 'Email';
      },
    ];
  };
}
export interface IMindboxColleagueRecommendationQuery {
  customerAction: {
    customFields: {
      companyrecomenduemogo: string[];
      innrecomenduemogo: string;
      lastnamerecomenduemogo: string;
      namerecomenduemogo: string;
      phonerecomenduemogo: string;
      regionrecomenduemogo: string;
      emailrecomenduemogo: string;
      companyNameRekomenatelya: string;
      lastNameRekomendatelya: string;
      nameRekomendatelya: string;
      telefonRekomendatelya: string;
      orderID: string;
      email: string;
      gift: string;
      employee: string;
      checkbox: boolean;
      uRLlink: string;
    };
  };
  customer: {
    firstName: string;
    lastName: string;
    mobilePhone: string;
    ids: {
      websiteidRecomend: string;
      mindboxId?: number;
    };
    customFields: {
      companyName: string[];
    };
    subscriptions: [
      {
        pointOfContact: 'Email';
      },
    ];
  };
}
export interface IMindboxColleagueRecommendationMindboxIdQuery {
  customerAction: {
    customFields: {
      companyrecomenduemogo: string[];
      innrecomenduemogo: string;
      lastnamerecomenduemogo: string;
      namerecomenduemogo: string;
      phonerecomenduemogo: string;
      regionrecomenduemogo: string;
      emailrecomenduemogo: string;
      companyNameRekomenatelya: string;
      lastNameRekomendatelya: string;
      nameRekomendatelya: string;
      telefonRekomendatelya: string;
      orderID: string;
      email: string;
      gift: string;
      employee: string;
      checkbox: boolean;
      uRLlink: string;
    };
  };
  customer: {
    firstName: string;
    lastName: string;
    mobilePhone: string;
    ids: {
      websiteidRecomend: string;
      mindboxId: number;
    };
    customFields: {
      companyName: string[];
    };
    subscriptions: [
      {
        pointOfContact: 'Email';
      },
    ];
  };
}

export interface IMindboxOtzyvQuery {
  customerAction: {
    customFields: {
      npsMark1?: number;
      npsMark2?: number;
      npsMark3?: number;
      npsMark4?: number;
      npsMark5?: number;
      message: string;
      orderID: string;

    };
  };
  customer: {
    ids: {
      mindboxId: string;
    };
  };
}
export interface IMindboxRecoveryQuery {
  customer: {
    email: string;
    firstName: string;
    mobilePhone: string;
    customFields: {
      region: string;
      urlpolucheniyaLida: string;
      ids: {
        websiteid: string;
      };
    };
    subscriptions: [
      {
        pointOfContact: 'Email';
      },
    ];
  };
}
export interface IMindboxAddProductToBucketQuery {
  addProductToList: {
    customFields: {
      buttonFrom: string;
    };
    product: {
      ids: {
        website: string;
      };
    };
  };
}
export interface IMindboxOpenPageQuery {
  viewProduct: {
    product: {
      ids: {
        website: string;
      };
    };
  };
}

export class MindboxService {
  private httpClient = new HttpRequest('https://api.mindbox.ru', {});

  /**
   * Форма запроса для расчета стоимости Консультант Плюс (/consultant-plus/prices)
   */
  public async calculateTheCost(query: IMindboxPaymentQuery) {
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>('/v3/operations/async?endpointId=4dk.Website&operation=RaschetStoimosti', query));
  }

  /**
   * Форма запроса большой тест драйв консультант
   */
  public async bigTestDrive(query: IMindboxBigTestDriveQuery) {
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>('/v3/operations/async?endpointId=4dk.Website&operation=Bolshoitestdrive', query));
  }

  /**
   * Форма запроса большой тест драйв консультант
   */
  public async getKomplektNalogovayareforma2025(query: IMindboxKomplektNalogovayareforma2025Query) {
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>('/v3/operations/async?endpointId=4dk.Website&operation=KomplektNalogovayareforma2025', query));
  }

  /**
   * Форма запроса рекомендация коллеги
   */
  public async postColleagueRecommendation(query: IMindboxColleagueRecommendationQuery) {
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>('/v3/operations/async?endpointId=4dk.Website&operation=RekomendaciiVProekteRekomendacii', query));
  }

  /**
   * Форма запроса рекомендация коллеги при наличии mindboxId
   */
  public async postColleagueRecommendationMindboxId(query: IMindboxColleagueRecommendationMindboxIdQuery) {
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>('/v3/operations/async?endpointId=4dk.Website&operation=RekomendaciiVProekteRekomendaciiMB', query));
  }

  /**
   * Форма запроса отзыва
   */
  public async postOtzyv(query: IMindboxOtzyvQuery) {
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>('/v3/operations/async?endpointId=4dk.Website&operation=OstavilNpsOZakaze', query));
  }

  /**
   * Форма запроса заказа консультанта по программе восстановления
   */
  public async getKPlusRecovery(query: IMindboxRecoveryQuery) {
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>('/v3/operations/async?endpointId=4dk.Website&operation=ZakazatKPlusvProekteVosstanovlenie', query));
  }

  /**
   * Добавление продукта в корзину
   */
  public async addProductToBucket(query: IMindboxAddProductToBucketQuery) {
    const deviceUUID = getMindboxDeviceUUID();

    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>(`/v3/operations/async?endpointId=4dk.Website&operation=AddProductToKorzinaNazhalNaKnopkuItemList&deviceUUID=${deviceUUID}`, query));
  }

  /**
   * Просмотр страницы
   */
  public async openPage(query: IMindboxOpenPageQuery) {
    const deviceUUID = getMindboxDeviceUUID();
    return useAsyncData(() => this.httpClient.post<{ status: 'Success' }>(`/v3/operations/async?endpointId=4dk.Website&operation=ViewPage&deviceUUID=${deviceUUID}`, query));
  }
}
